import React, { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Products from "@/components/Products";
import Process from "@/components/Process";
import InquiryForm from "@/components/InquiryForm";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import SmoothScrollProvider, { smoothScrollTo } from "@/lib/SmoothScroll";
import ProductDetail from "@/pages/ProductDetail";

/** Scroll to the hash target (with delay for section mount) */
const HashScroller = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const attempt = () => {
        const el = document.getElementById(id);
        if (el) smoothScrollTo(el, { offset: -80 });
      };
      // Delay so target sections mount before scrolling
      const t1 = setTimeout(attempt, 100);
      const t2 = setTimeout(attempt, 500);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
      };
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
};

const Home = () => (
  <main
    className="min-h-screen bg-[#FAF9F6] text-[#0A192F] font-body"
    data-testid="page-home"
  >
    <Navbar />
    <Hero />
    <About />
    <Products />
    <Process />
    <InquiryForm />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScrollProvider>
          <HashScroller />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
          </Routes>
          <WhatsAppFab />
        </SmoothScrollProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
